import BrickFactory from "./containers/BrickFactory";
export default BrickFactory;